import { color, Root, Series } from '@amcharts/amcharts5';
import { AxisRenderer, DateAxis, ValueAxis, XYChart } from '@amcharts/amcharts5/xy';
import { renderToString } from 'react-dom/server';

import MonetisationHealthTooltip from 'features/Health/components/MonetisationHealthChart/components';
import { setAxisMaxValue } from 'features/Health/components/MonetisationHealthChart/utils/setAxisMaxValue';
import {
  graphicsSettings,
  lineSeriesSettings,
  tooltipSettings,
} from 'features/Health/components/MonetisationHealthChart/utils/settings';
import { HealthMetricsHistory } from 'features/Health/containers/MonetisationHealthChartContainer/types/healthMetrics';
import { bullet, circle, lineSeries, toolTip } from 'utils/charts/charts';
import { DELIVERY_COLOUR, DEMAND_COLOUR } from 'utils/colours';
import { DELIVERY_RATE, DEMAND_RATE } from 'utils/defaults';

export const setSeries = (
  root: Root,
  chart: XYChart,
  xAxis: DateAxis<AxisRenderer>,
  yAxis: ValueAxis<AxisRenderer>,
  chartData: {
    demand: HealthMetricsHistory[];
    delivery: HealthMetricsHistory[];
  }
) => {
  const deliveryRateSeries = chart.series.push(
    lineSeries(root, lineSeriesSettings(DELIVERY_RATE, DELIVERY_COLOUR, xAxis, yAxis))
  );
  const demandRateSeries = chart.series.push(
    lineSeries(root, lineSeriesSettings(DEMAND_RATE, DEMAND_COLOUR, xAxis, yAxis))
  );

  const tooltip = toolTip(root, tooltipSettings);
  tooltip.get('background')?.setAll(graphicsSettings);

  deliveryRateSeries.bullets.push((currentRoot: Root, _: Series) => {
    return bullet(currentRoot, {
      locationX: 0,
      sprite: circle(currentRoot, {
        fill: color(DELIVERY_COLOUR),
        radius: 4,
        tooltipHTML: renderToString(
          <MonetisationHealthTooltip title={DELIVERY_RATE} colour={DELIVERY_COLOUR} />
        ),
        tooltip: tooltip,
      }),
    });
  });

  demandRateSeries.bullets.push((currentRoot: Root, _: Series) => {
    return bullet(currentRoot, {
      locationX: 0,
      sprite: circle(currentRoot, {
        fill: color(DEMAND_COLOUR),
        stroke: color(DEMAND_COLOUR),
        radius: 4,
        tooltipHTML: renderToString(
          <MonetisationHealthTooltip title={DEMAND_RATE} colour={DEMAND_COLOUR} />
        ),
        tooltip: tooltip,
      }),
    });
  });

  root.dateFormatter?.setAll({
    dateFormat: 'dd-MM-yyyy, HH:mm',
    dateFields: ['valueX'],
  });

  deliveryRateSeries.data.setAll(chartData.delivery);
  demandRateSeries.data.setAll(chartData.demand);
  setAxisMaxValue(chartData.delivery, yAxis);
  setAxisMaxValue(chartData.demand, yAxis);
};
